/* eslint-disable arrow-body-style */
import React, { useMemo } from 'react';
import SalesOverviewTopChartCo from '../../../SalesOverview/components/SalesOverviewTopChartCo';
import { getLocale } from 'umi';
import { useSelectorMap } from '@/pages/dashboard/utils/customHook';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';
import { dynamicString } from '@home/utils/dynamicString';
import { resolveBySegmentType } from '../../../SalesOverview/utils/resolveBySegmentType';


const IngameDlpTopChartContext = (props: any) => {
  const { config, data: apiData, extMetricMap, setSortTopMetric, secTitle } = props || {};
  
  const { chart, top10TitleEn, top10TitleCn, titleNameEn, titleNameCn, defaultSortMetric = 'platform_net_units_sold', sortMetric } = config || {};
  const { by_type: byType, breakDownData, segmentVal } = apiData || {};
  const isEN = getLocale() === 'en-US';
  const { getFilterItemText } = useSelectorMap();
  const metricsInfoSignature = JSON.stringify(apiData?.data?.metricsInfo || {});
  // 标题相关
  const { top10Title, titleName } = useMemo(() => {
    // 兼容字符串形式的函数配置，使用 stringToFunction 转换
    let top10Title = stringToFunction(isEN ? top10TitleEn : top10TitleCn);
    let titleName = stringToFunction(isEN ? titleNameEn : titleNameCn);
    if (typeof top10Title === 'function') {
      top10Title = top10Title(segmentVal);
    }
    if (typeof titleName === 'function') {
      titleName = titleName(segmentVal);
    }
    return {
      top10Title,
      titleName
    };
  }, [isEN, segmentVal]);

  // 数据处理
  const dataList = useMemo(() => {
    return chart?.map((val: { [key: string]: string; }) => {
      const { data, loading, errorMsg } = breakDownData || {};
      const { metric } = val || {};
      // 使用 dynamicString 解析 format 和 percentFormat，支持 {{metricsInfo.xxx.formatter}} 模板
      const format = dynamicString(val?.format, apiData?.data);
      const percentFormat = dynamicString(val?.percentFormat, apiData?.data);
      // , format_ext1, percent_format_ext1
      const contrastMetric = extMetricMap?.[metric];
      const contrastObj = chart?.filter((item: { metric: any; })=>item?.metric === contrastMetric)?.[0];
      const contrastFormat = dynamicString(contrastObj?.format, apiData?.data);
      const contrastPercentFormat = dynamicString(contrastObj?.percentFormat, apiData?.data);

      const allDataList = data?.[val?.metric]?.map((item: { [key: string]: string; }) => ({
        ...item,
        num: dataFormat({ value: item?.value, formatRule: format }),
        name: getFilterItemText(byType, item?.name, item?.full_name) || '',
        percentage: dataFormat({ value: item?.share_off_all, formatRule: percentFormat }),
        num_ext1: dataFormat({ value: item?.value_ext1, formatRule: contrastFormat }),
        percentage_ext1: dataFormat({ value: item.share_off_all_ext1, formatRule: contrastPercentFormat }),
        format: format || 'thousandsInit'
      }));
      // 和产品确认后，大于10并且others不为空的时候展示others
      const othersItem = allDataList?.filter((item: { full_name: string; }) => item?.full_name?.toLowerCase() === 'others') || [];
      const othersIsNull = othersItem?.[0]?.value === '';
      const isMoreThanTen = allDataList?.length > 10;
      const dataArr = (!othersIsNull && isMoreThanTen) ? allDataList : allDataList?.filter((item: { full_name: string; }) => item?.full_name?.toLowerCase() !== 'others') || [];
      // 支持按 Product / Product Category 动态列名，并兼容 {{metricsInfo.xxx.en}} 模板
      const headerEn = resolveBySegmentType(val.name, segmentVal, apiData?.data, val.metric || '');
      const headerCn = resolveBySegmentType(val.nameCn, segmentVal, apiData?.data, val.metric || '');
      return {
        title: val.metric,
        listHeader: isEN ? headerEn : headerCn,
        isLoading: loading,
        isError: errorMsg !== '',
        isNoData: dataArr?.length === 0,
        list: dataArr || []
      };
    }) || [];
  }, [chart, breakDownData, extMetricMap, isEN, getFilterItemText, byType, segmentVal, metricsInfoSignature]);
  return (
    <>
      <SalesOverviewTopChartCo
        setSortTopMetric={setSortTopMetric}
        data={dataList}
        defaultSortedVal={defaultSortMetric}
        sortValue={sortMetric}
        byType={byType}
        title={top10Title}
        firstHeader={titleName}
        config={config}
        apiData={apiData?.data}
        segmentVal={segmentVal}
        secTitle={secTitle}
      />
    </>
  );
};

export default IngameDlpTopChartContext;